import { createContext, useContext } from "react";
import {
  ProgramTemplateCategory,
  ProgramTemplateType,
} from "@growth-machine-llc/stridist-api-client";
import { ProgramTemplateSort } from "../components/program-library/filters/ProgramNameSortButton";

export const AllOption = "ALL" as const;

export type AllOptionType = typeof AllOption;

export type ProgramTemplateFilterType = ProgramTemplateType | AllOptionType;

export interface ProgramListFilterContextValues {
  query: string;
  sortKey: ProgramTemplateSort;
  category: ProgramTemplateCategory[] | AllOptionType;
  templateType: ProgramTemplateFilterType;
  handleQueryChange: (query: string) => void;
  handleSortKeyChange: (sortKey: ProgramTemplateSort) => void;
  handleCategoryChange: (
    category: ProgramTemplateCategory[] | AllOptionType,
  ) => void;
  handleTemplateTypeChange: (type: ProgramTemplateFilterType) => void;
}

export const ProgramListFilterContext = createContext<
  ProgramListFilterContextValues | undefined
>(undefined);

export const useProgramListFilterContext = () => {
  const context = useContext(ProgramListFilterContext);
  if (!context) {
    throw new Error(
      "useProgramListFilterContext must be used within ProgramListFilterContext.Provider",
    );
  }
  return context;
};
